export default __webpack_public_path__ + "static/media/gamePlayBg.d825bb6a.png";